import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../app.material';
import { CoreModule } from '../core/core.module';
import { LoaderComponent } from './loader/loader.component';
import { OnlyNumberDirective } from './only-number.directive';
import { FilterPipe } from './filter.pipe';
import { DecimalDirective } from './decimal.directive';
import { UniquePipe } from './pipes/unique.pipe';
import { HoursMinutesPipe } from './pipes/hours-minutes.pipe';

/**
 * SharedModule
 */
@NgModule({
	imports: [CommonModule, CoreModule, FormsModule, ReactiveFormsModule, MaterialModule, FlexLayoutModule],
	declarations: [LoaderComponent, DecimalDirective, OnlyNumberDirective, FilterPipe, UniquePipe, HoursMinutesPipe],
	exports: [
		CommonModule,
		CoreModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		LoaderComponent,
		FilterPipe,
		UniquePipe,
		DecimalDirective,
		OnlyNumberDirective,
		HoursMinutesPipe
	]
})
export class SharedModule {}
